<!--
 * @Author: ZhaoG
 * @Date: 2026-03-17 17:06:14
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-03-25 10:42:49
 * @FilePath: \sra-fe\src\views\register\material\maPerfectInfo\chooseTree1.vue
 * @Description:
-->
<template>
  <div class="el-material-selector">
    <el-dialog
      maxHeight="null"
      width="500px"
      :title="$t('page.productInfo.dialog.title')"
      @close="close"
      :visible.sync="dialogFormVisible1"
      custom-class="sorting-code-number"
    >
      <div class="el-dialog__body-bodys" v-if="dialogFormVisible1">
        <div class="treeBox">
          <el-tree
            :props="treeProps"
            :load="loadNode"
            ref="tree"
            node-key="id"
            :default-checked-keys="defaultData"
            :expand-on-click-node="false"
            :check-strictly="false"
            show-checkbox
            :draggable="false"
            lazy
            show-line
          >
          </el-tree>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="cancel">{{
          $t("page.productInfo.btn.cancel")
        }}</el-button>
        <el-button size="mini" type="primary-font-mini" @click="handleTrue">{{
          $t("page.productInfo.btn.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Cookies from "js-cookie";
import { qryMatcateryTreeList } from "@/api/supRegister";

export default {
  name: "chooseTree",
  watch: {
    dialogFormVisible(item) {
      this.dialogFormVisible1 = item;
      if (item) {
        this.tableData = [];
        this.materialsData = [];
        this.isTurnPage = false;
        this.formData = {
          // matName: '',
          // matNum: '',
          pageNo: 1,
          pageSize: 10,
          // catalogId: '',
          matcateryLevel: "",
          matcateryCode: "",
          matcateryAlias: "",
          matcodeName: ""
        };
      }
    }
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    headers: {
      type: Object,
      default: () => {
        return {
          APP_TOKEN: Cookies.get("appToken"),
          Authorization: Cookies.get("access_token")
        };
      }
    },
    defaultData: {
      type: Array,
      default: []
    },
    greenCarbonType: {
      type: String,
      default: ""
    }
  },
  created() {},
  data() {
    return {
      lineClampBody: true,
      loading: false,
      dialogFormVisible1: this.dialogFormVisible,
      conditionCheckbox: true,
      tableData: [],
      treeProps: {
        label: "name",
        children: "qryMatcateryTreeBOList",
        isLeaf: "leaf"
      },
      gridData: [],
      greenCarbonTypeList: [
        {
          label: "水泥",
          value: "02",
          key: "2"
        },
        {
          label: "钢材",
          value: "01",
          key: "3"
        },
        {
          label: "沥青",
          value: "03",
          key: "4"
        }
      ],
      dialogTableVisibletextarea: false,
      formData: {
        pageNo: 1,
        pageSize: 10,
        matcateryLevel: "",
        matcateryCode: "",
        matcateryAlias: "",
        matcodeName: ""
      },
      textarea: "",
      formLabelWidth: "120px",
      present: "",
      total: 0,
      lastTime: {
        button: false
      },
      materialsData: [], // 物资选择数据
      isTurnPage: false, // 是否有翻页
      treeArray: []
    };
  },
  methods: {
    close() {
      this.$emit("update:dialogFormVisible", false);
    },
    cancel() {
      this.$emit("update:dialogFormVisible", false);
    },
    loadNode(node, resolve) {
      console.log(node, "node");

      if (node.level === 0) {
        qryMatcateryTreeList({
          parentMatcateryCode: "00"
        }).then(res => {
          const nodes = res.data.data.map(item => ({
            id: item.matcateryCode,
            qryMatcateryTreeBOList: [],
            matcateryCodeMid: item.matcateryCodeMid,
            name: item.matcateryName,
            matcateryNameMid: item.matcateryNameMid,
            matcateryCodeBig: item.matcateryCodeBig,
            matcateryNameBig: item.matcateryNameBig,
            leaf: window.languagezh_cn ? item.isOrder != 0 : true,
            parentMatcateryCode: item.parentMatcateryCode,
            matcateryTreePath: item.matcateryTreePath,
            unitName: item.unitName,
            unitCode: item.unitCode,
            level: item.matcateryLevel,
            matcateryCodeSmall: item.matcateryCode,
            matcateryNameSmall: item.matcateryName
          }));
          resolve(nodes);
          // console.log(nodes, "打印服务数据");
        });
      } else if (node.level < 3) {
        qryMatcateryTreeList({
          parentMatcateryCode: node.data.id
        }).then(res => {
          const nodes = res.data.data.map(item => ({
            id: item.matcateryCode,
            matcateryCodeMid: item.matcateryCodeMid,
            name: item.matcateryName,
            matcateryNameMid: item.matcateryNameMid,
            qryMatcateryTreeBOList: [],
            leaf: item.isOrder != 0,
            parentMatcateryCode: item.parentMatcateryCode,
            matcateryTreePath: item.matcateryTreePath,
            unitName: item.unitName,
            unitCode: item.unitCode,
            level: item.matcateryLevel,
            matcateryCodeSmall: item.matcateryCode,
            matcateryNameSmall: item.matcateryName,
            matcateryCodeBig: item.matcateryCodeBig,
            matcateryNameBig: item.matcateryNameBig
          }));
          resolve(nodes);
          // console.log(nodes, "打印服务数据++");
        });
      }
      if (node.level > 1) return resolve([]);
    },
    handleTrue() {
      // let treeData = this.forData(this.$refs.tree.getCheckedNodes());
      let treeData = this.$refs.tree.getCheckedNodes();
      console.log(treeData, "打印服务数据+++");
      const hasThirdLevel = treeData.filter(node => node.level == 3) || [];
      if (hasThirdLevel.length == 0) {
        this.$message.warning("请选择第三级数据");
        return; // 不关闭弹窗
      }
      if (this.greenCarbonType && this.greenCarbonType != 1) {
        let infoNum = "";
        infoNum = this.greenCarbonTypeList.find(
          item => item.key == this.greenCarbonType
        ).value;
        // greenCarbonType 2 - 水泥；3 - 钢材；4 - 沥青
        //matcateryCodeBig 01 - 钢材；02 - 水泥；03 - 沥青
        // 新增判断逻辑：校验所有选中节点的 matcateryCodeBig 是否与 infoNum 一致
        const isAllMatch = hasThirdLevel.every(
          node => node.matcateryCodeBig === infoNum
        );
        if (!isAllMatch) {
          this.$message.warning("所选物资与当前类别不一致，请确认");
        }
      }
      this.$emit("handleTrue", hasThirdLevel);
      this.$emit("update:dialogFormVisible", false);
    },
    forData(treeData) {
      let _this = this;
      let treeData1 = JSON.parse(JSON.stringify(treeData));
      treeData.map(item => {
        let id = item.id;
        for (let i = treeData1.length - 1; i >= 0; i--) {
          if (treeData1[i].matcateryTreePath.indexOf("-" + id + "-") !== -1) {
            _this.$delete(treeData1, i);
          }
        }
      });
      return treeData1;
    }
  }
};
</script>
<style scoped>
.el-dialog__body-bodys {
  height: 100%;
  width: 460px;
  border: 1px solid #f2f2f2;
  overflow: auto;
  float: left;
}
</style>
